import { z } from 'zod';
/**
 * Payload shape for `GET /my-chargers/:id/throughput-series`.
 *
 * Owner-scoped utilisation series — counts sessions completed and
 * kWh delivered per bucket. Distinct from revenue-series (which
 * tracks cleared payouts in dollars) because throughput surfaces
 * usage signal even when sessions are guest-billed to the network
 * or fleet-billed to another tenant. The MyChargerSessionsPage
 * chart wraps this so the owner can see "what's actually happening
 * on my charger" independent of "what's actually cleared as
 * earnings."
 *
 * Status filter mirrors operator-summary's COMPLETED_STATUSES
 * (`completed`, `stopped_by_user`, `stopped_by_system`) — billed
 * sessions only, no cancellations / failures inflating the count.
 *
 * All three periods supported: '24h' (24 hourly buckets), '7d'
 * (7 daily buckets), '30d' (30 daily buckets). Unlike revenue-
 * series (where payouts clear at most once per day, making 24h
 * a flat-zero line), session activity happens continuously so
 * hourly granularity is meaningful.
 */
export const MyChargerThroughputSeriesPeriodSchema = z.enum(['24h', '7d', '30d']);
export const MyChargerThroughputSeriesBucketSchema = z.object({
    sessions: z.number().int().nonnegative(),
    kwh: z.number().nonnegative(),
});
export const MyChargerThroughputSeriesSchema = z.object({
    /** Per-period buckets, oldest first. Length matches window:
     *  24 for '24h', 7 for '7d', 30 for '30d'. Each bucket carries
     *  session count + kWh delivered. Empty windows return arrays of
     *  zero-buckets (NOT null). */
    buckets: z.array(MyChargerThroughputSeriesBucketSchema),
    /** Window the buckets cover. Echoes back the request period. */
    window: MyChargerThroughputSeriesPeriodSchema,
    /** Sum of session counts across all buckets. */
    totalSessions: z.number().int().nonnegative(),
    /** Sum of kWh across all buckets. */
    totalKwh: z.number().nonnegative(),
});
//# sourceMappingURL=me-charger-throughput-series.js.map